var addQueryParamToUrl = function addQueryParamToUrl(_ref) {
  var url = _ref.url,
    key = _ref.key,
    value = _ref.value;
  var splittedUrl = url.split(/\?(.+)/);
  var baseUrl = splittedUrl[0];
  var currentQueryParams = splittedUrl[1];
  return "".concat(baseUrl, "?").concat(currentQueryParams ? "".concat(currentQueryParams, "&") : '').concat(key, "=").concat(value);
};
export default addQueryParamToUrl;